import { render, staticRenderFns } from "./38_mv_decrementables.vue?vue&type=template&id=f9b534b2&scoped=true&"
import script from "./38_mv_decrementables.vue?vue&type=script&lang=js&"
export * from "./38_mv_decrementables.vue?vue&type=script&lang=js&"
import style0 from "./38_mv_decrementables.vue?vue&type=style&index=0&id=f9b534b2&scoped=true&lang=css&"
import style1 from "./38_mv_decrementables.vue?vue&type=style&index=1&id=f9b534b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b534b2",
  null
  
)

export default component.exports